import { useLocation } from '@tanstack/react-router';
import { creditsPurchasePageName, type CreditsPurchasePageName } from '../utils/credits-purchase-page-name';

/** The `page_name` for a purchase opened on the current billing tab. */
export function useCreditsPurchasePageName(): CreditsPurchasePageName {
  return creditsPurchasePageName(useLocation().pathname);
}
